import React from 'react';
import { motion } from 'framer-motion';
import { Watermark } from './Watermark';
export function CTASection() {
  return <section className="py-14 sm:py-20 lg:py-24 px-5 sm:px-6 bg-luxury-black text-white relative overflow-hidden" data-id="element-113" data-mp="27hf50ky2lh7d">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10" data-id="element-114" data-mp="2hetkah89bzy3">
        <div className="absolute top-[-20%] right-[-10%] w-96 h-96 bg-gold rounded-full filter blur-3xl" data-id="element-115" data-mp="2me66czrb12zm"></div>
        <div className="absolute bottom-[-20%] left-[-10%] w-96 h-96 bg-gold rounded-full filter blur-3xl" data-id="element-116" data-mp="2qezthqwxadrg"></div>
      </div>

      <Watermark position="center" size={850} opacity={0.07} dark data-id="element-117" data-mp="2v79jt81y9fu9" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-118" data-mp="3051gsghgbs5b">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-119" data-mp="307ffczbcbmhm">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-6" data-id="element-120" data-mp="1w758wq27lceh">
            ELEVA TU IMAGEN PROFESIONAL HOY
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 font-sans font-light mb-10" data-id="element-121" data-mp="1r93sye02xt78">
            Haz que cada cita refleje organización, lujo y profesionalismo.
          </p>

          <motion.a href="#disponible-en" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-gold hover:bg-gold-light text-luxury-black font-sans font-bold text-lg tracking-widest uppercase px-12 py-5 rounded-sm transition-colors duration-300 shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-122" data-mp="2jx9ev42vdo8n">
            ORDENAR MI KIT
          </motion.a>
        </motion.div>
      </div>
    </section>;
}